module.exports = __webpack_public_path__ + "static/media/global-goals.efdd6666.svg";